import script from "./Paid.vue?vue&type=script&setup=true&lang=js"
export * from "./Paid.vue?vue&type=script&setup=true&lang=js"

import "./Paid.vue?vue&type=style&index=0&id=5cb6b9a8&lang=css"

const __exports__ = script;

export default __exports__